import {
  getSpotAndGreeksEquity,
  getSpotAndGreeksForex,
} from 'components/common-form/builder/form/node/field/SpotAndGreeksField/SpotAndGreeks.helper';
import { Underlying } from 'models/underlying';
import { useMemo } from 'react';
import { GreeksTable } from 'state/quotes/details/details.model';

export function useSpotAndGreeks(greeksEntry: Nullable<GreeksTable>, underlyings: readonly Underlying[]) {
  return useMemo(() => {
    if (greeksEntry?.assetClass === 'Forex') {
      return getSpotAndGreeksForex(greeksEntry, underlyings);
    }

    return getSpotAndGreeksEquity(greeksEntry, underlyings);
  }, [greeksEntry, underlyings]);
}
